module.exports = __webpack_public_path__ + "img/team-2.008578f3.jpg";